export default {"src":"/_next/static/media/Pause.6d05012e.svg","height":16,"width":16};